'use strict';

function mixImmediate(a, b) {
    return (p) => (p > 0 ? b : a);
}

exports.mixImmediate = mixImmediate;
//# sourceMappingURL=immediate.cjs.map
